import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'discard-changes-dialog.heading': {
    id: 'discard-changes-dialog.heading',
    defaultMessage: 'Unsaved changes',
    description: 'The heading text for the discard changes warning dialog'
  },
  'discard-changes-dialog.no-button-text': {
    id: 'discard-changes-dialog.no-button-text',
    defaultMessage: 'Keep editing',
    description: 'Text for the keep editing button in the discard changes dialog'
  },
  'discard-changes-dialog.warning-body': {
    id: 'discard-changes-dialog.warning-body',
    defaultMessage: 'Are you sure you want to discard the changes you have made?',
    description: 'A message confirm if the user actually wants to discard changes'
  },
  'discard-changes-dialog.yes-button-text': {
    id: 'discard-changes-dialog.yes-button-text',
    defaultMessage: 'Discard changes',
    description: 'Text for the discard changes button in the discard changes dialog'
  },
  'setup-panel.replace-database-heading': {
    id: 'setup-panel.replace-database-heading',
    defaultMessage: 'Delete and replace database?',
    description:
      'The heading for the confirmation dialog when a user wants to change the setup of their database. It warns the user that proceeding with the action will override existing data.'
  },
  'setup-panel.replace-database-body': {
    id: 'setup-panel.replace-database-body',
    defaultMessage:
      'Changing the setup of the database will remove existing data. All fields and values in this database and its embeds will be removed and replaced.',
    description:
      'The confirmation message when a user wants to change the setup of their database. It warns the user that proceeding with the action will override existing data.'
  },
  'setup-panel.replace-database-cancel-button': {
    id: 'setup-panel.replace-database-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The cancel button for the confirmation dialog when a user wants to change the setup of their database.'
  },
  'setup-panel.replace-database-replace-button': {
    id: 'setup-panel.replace-database-replace-button',
    defaultMessage: 'Replace database',
    description:
      'The ok button for the confirmation dialog when a user wants to change the setup of their database. It lets the user know that proceeding will replace the existing database.'
  }
});
